import React from "react";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './assets/css/toaster.css'

const Toasters = () => {
    return <ToastContainer autoClose={3000} position="bottom-right" hideProgressBar={true} />
}

export default Toasters
